import script from "./NewContractPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContractPanel.vue?vue&type=script&setup=true&lang=js"

import "./NewContractPanel.vue?vue&type=style&index=0&id=2a905786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a905786"]])

export default __exports__